import { render, staticRenderFns } from "./stockInOuRecord.vue?vue&type=template&id=0f677e9f"
import script from "./stockInOuRecord.vue?vue&type=script&lang=js"
export * from "./stockInOuRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports